import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import authService from './authService';

const token = localStorage.getItem('token')
const role = localStorage.getItem('role')

const initialState = {
    token: token ? token : '',
    role: role ? role : '',
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
};

// Register user
export const registerDC = createAsyncThunk(
    'auth/register',
    async (user, thunkAPI) => {
        try {
            return await authService.register(user)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const login = createAsyncThunk('auth/login', async (user, thunkAPI) => {
    try {
        return await authService.login(user)
    } catch (error) {
        const message =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const logout = createAsyncThunk('auth/logout', async () => {
    await authService.logout()
})

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(registerDC.pending, (state) => {
                state.isLoading = true
            })
            .addCase(registerDC.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.message = action.payload.message
            })
            .addCase(registerDC.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(login.pending, (state) => {
                state.isLoading = true
            })
            .addCase(login.fulfilled, (state, action) => {
                console.log("Sucess", action.payload)
                authService.setToken(action.payload.token)
                authService.setRole(action.payload.role)
                console.log(action.payload);
                if(action.payload.role != "admin"){
                authService.setDist(action.payload.districtId);
                authService.setRole(action.payload.role);
                }else{
                    authService.setAdminname(action.payload.firstName);
                }
                authService.setUserId(action.payload.userId)
                localStorage.setItem('firstName', action.payload.firstName)
                localStorage.setItem('lastName', action.payload.lastName)
                state.isLoading = false
                state.isSuccess = true
                state.token = action.payload.token
                state.role = action.payload.role
                state.message = action.payload.message
            })
            .addCase(login.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.token = ''
                state.role = ''
            })
            .addCase(logout.fulfilled, (state) => {
                state.token = '';
                state.role = '';
                state.isError= false;
                state.isSuccess= false;
                state.isLoading= false;
                state.message =  '';
                authService.logout();
            })
    }

});

export const { reset } = authSlice.actions;

export default authSlice.reducer;